module.exports = __webpack_public_path__ + "static/media/24.ff7ae802.jpg";